import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';

import { responseHandle, errorHandle } from '../utils/callback-handle';

import requests from '../api/api';

const initialState:any = {
  applications: []
};

export const SecurityContext = React.createContext(initialState);

export const SecurityProvider = ({ children }) => {

  const TOKEN_COOKIE = '_ssoToken';

  const api = axios.create({ 
    baseURL: process.env.REACT_APP_API_URL, 
    headers: { 
      'Content-Type': 'application/json',
      'VLR-Authorization': btoa(JSON.stringify({ "id": process.env.REACT_APP_ID }))
    } 
  });
  
  api.interceptors.request.use (
    request => {
      const idToken = Cookies.get(TOKEN_COOKIE);
      if (!idToken) {
          request.cancelToken = new axios.CancelToken((cancel) => cancel('Token Expired'));
      } else {
          request.headers['Authorization'] = idToken;
      }
      return request
    },
    error => {
      return Promise.reject(error)
    }
  )
  
  const [applicationsData, setApplicationsData] = useState({tableData: []});
  const [profilesData, setProfilesData] = useState({tableData: []});
  const [usersData, setUsersData] = useState({tableData: [], foreignData: []});
  const [servicesData, setServicesData] = useState({tableData: [], foreignData: []});

  const [dashboardData, setDashboardData] = useState([]);
  const [viewActivityData, setViewActivityData] = useState(null);
  const [manageUsersData, setManageUsersData] = useState({users: [], application: null});
  const [searchUsersData, setSearchUsersData] = useState([]);


  const getReport = (id: string) => {
    return new Promise<void>((resolve, reject) => {
      requests.getReport(id).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };

  const getDashboardData = () => {
    setDashboardData([]);
    return new Promise<void>((resolve, reject) => {
      requests.getDashboardData().then(response => {
          const data = responseHandle(response);
          setDashboardData(data);
          resolve();
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };

  const getViewActivityData = (id: string) => {
    setViewActivityData(null);
    return new Promise<void>((resolve, reject) => {
      requests.getViewActivityData(id).then(response => {
          const data = responseHandle(response);
          setViewActivityData(data);
          resolve();
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const getManageUsersData = (id: string) => {
    setManageUsersData({users: [], application: null});
    return new Promise<void>((resolve, reject) => {
      requests.getManageUsersData(id).then(response => {
          const data = responseHandle(response);
          setManageUsersData(data);
          resolve();
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const getUserData = (applicationId: string, userId: string) => {
    return new Promise<void>((resolve, reject) => {
      requests.getUserData(applicationId, userId).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const saveUserData = (data: any) => {
    return new Promise<void>((resolve, reject) => {
      requests.saveUserData(data).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const removeUserData = (id: string) => {
    return new Promise<void>((resolve, reject) => {
      requests.removeUserData(id).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const resetUserPassword = (email: string) => {
    return new Promise<void>((resolve, reject) => {
      requests.resetUserPassword(email).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const applyUserData = (data: Array<any>) => {
    return new Promise<void>((resolve, reject) => {
      requests.applyUserData(data).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const changeUserAppStatus = (id: string, applicationId: string, inactive: boolean) => {
    return new Promise<void>((resolve, reject) => {
      requests.changeUserAppStatus(id, applicationId, inactive).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  

  const getRequestUserData = (applicationId: string, ids: Array<string>) => {
    return new Promise<void>((resolve, reject) => {
      requests.getRequestUserData(applicationId, ids).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const getUserPicture = (id: string) => {
    return new Promise<void>((resolve, reject) => {
      requests.getUserPicture(id).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  
  
  const uploadUserPicture = (id: string, data: any) => {
    return new Promise<void>((resolve, reject) => {
      requests.uploadUserPicture({ upload: { id: id, data: data} }).then(response => {
          const data = responseHandle(response);
          resolve(data);
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const getSearchUsersData = (searchText: string) => {
    setSearchUsersData([]);
    return new Promise<void>((resolve, reject) => {
      requests.getSearchUsersData(searchText).then(response => {
          const data = responseHandle(response);
          setSearchUsersData(data);
          resolve();
        }).catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const applicationsManagement = (params) => {
    setApplicationsData({tableData: []});
    return new Promise<void>((resolve, reject) => {
      api.post('/application/management', params)
        .then(response => {
          const data = responseHandle(response);
          setApplicationsData(data);
          resolve();
        })
        .catch(error => {
          reject(errorHandle(error));
        });
      });
  };


  const applicationsSettings = (params) => {
    return new Promise<any>((resolve, reject) => {
      api.post('/application/settings', params)
        .then(response => {
          const data = responseHandle(response);
          resolve(data);
        })
        .catch(error => {
          reject(errorHandle(error));
        });
      });
  };
    
  const profilesManagement = (params) => {
    setProfilesData({tableData: []});
    return new Promise<void>((resolve, reject) => {
      api.post('/profile/management', params)
        .then(response => {
          const data = responseHandle(response);
          setProfilesData(data);
          resolve();
        })
        .catch(error => {
          reject(errorHandle(error));
        });
      });
  };  
  

  const profilesDashboard = (params) => {
    setProfilesData({tableData: []});
    return new Promise<void>((resolve, reject) => {
      api.post('/dashboard/profile', params)
        .then(response => {
          const data = responseHandle(response);
          setProfilesData(data);
          resolve();
        })
        .catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const usersManagement = (params) => {
    setUsersData({tableData: [], foreignData: []});
    return new Promise<void>((resolve, reject) => {
      api.post('/user/management', params)
        .then(response => {
          const data = responseHandle(response);
          setUsersData(data);
          resolve();
        })
        .catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const servicesManagement = (params) => {
    setServicesData({tableData: [], foreignData: []});
    return new Promise<void>((resolve, reject) => {
      api.post('/service/management', params)
        .then(response => {
          const data = responseHandle(response);
          setServicesData(data);
          resolve();
        })
        .catch(error => {
          reject(errorHandle(error));
        });
      });
  };  

  const renderStore = <SecurityContext.Provider value={{
      applicationsData,
      applicationsManagement,
      applicationsSettings,
      profilesData,
      profilesManagement,
      usersData,
      usersManagement,
      servicesData,
      servicesManagement,
      dashboardData,
      getDashboardData,
      viewActivityData,
      getViewActivityData,
      manageUsersData,
      getManageUsersData,
      getUserData,
      saveUserData,
      removeUserData,
      resetUserPassword,
      applyUserData,
      changeUserAppStatus,
      getRequestUserData,
      getUserPicture,
      uploadUserPicture,
      searchUsersData,
      getSearchUsersData,
      profilesDashboard,
      getReport
    }}>
      {children}
    </SecurityContext.Provider>;

  return renderStore;

}    